

// Libraries
import { Col, Container, Navbar, Row, Button, Tab, Tabs } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { AnimatePresence, m } from 'framer-motion'
import { Form, Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Parallax } from "react-scroll-parallax";
import { Helmet } from "react-helmet";
import React, { useState, useRef, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";

// Components
import { fadeIn, fadeInLeft, zoomIn } from '../Functions/GlobalAnimations'
import FooterStyle from '../Pages/Footer/Footer';

import MainHeader from "../Pages/Header/MainHeader";
import { IMAGE_PATHS } from '../Functions/Constant';
import { useNavigate } from "react-router-dom";
import Accordions from '../Components/Accordion/AccordionC'
import MessageBox from "../Components/MessageBox/MessageBox";
import { resetForm, sendEmail } from "../Functions/Utilities";
import Buttons from '../Components/Button/Buttons'
import HeaderForBus from "../Pages/Header/HeaderForBus";
import { Checkbox, Input, TextArea } from '../Components/Form/Form'
import SocialIcons from '../Components/SocialIcon/SocialIcons';
import API from '../Api/Api';
import ContactForm from '../Pages/ComponentPage/ContactForm';
import LetGo from "../Pages/ComponentPage/LetGo";
import { AccordionData } from '../Components/Accordion/AccordionData'
import ButtonsVariant from '../Components/Button/ButtonVariant'; // Fixed: Use default import
//Data
const SocialIconsData = [
    {
        color: "#3b5998",
        link: "https://www.facebook.com/profile.php?id=61575541327116",
        icon: "fab fa-facebook-f"
    },
    {
        color: "#00aced",
        link: "https://x.com/home",
        icon: "fab fa-twitter"
    },
    {
        color: "#fe1f49",
        link: "https://www.instagram.com/jobcritics/",
        icon: "fab fa-instagram"
    },
    {
        color: "#007bb6",
        link: "https://www.linkedin.com/in/job-critics-ab01b4359",
        icon: "fab fa-linkedin-in"
    },
]


const Home = (props) => {
    const [successMsg, setSuccessMsg] = React.useState(false);
    const jobcritic_usertype = localStorage.getItem("jobcritic_usertype");
    const form = useRef(null)
    const navigate = useNavigate();
   
    const [isRecaptchaVerified, setIsRecaptchaVerified] = useState(false);
        const recaptchaRef = useRef();
    
        useEffect(() => {
            console.log("reCAPTCHA script is assumed to be loaded via index.html");
        }, []);
    
        const handleRecaptchaChange = (value) => {
            setIsRecaptchaVerified(!!value);
        };
    


    const ContactFormStyle02Schema = Yup.object().shape({
        name: Yup.string().required("Field is required."),
        email: Yup.string()
            .required("Field is required.")
            .matches(/^\d+$/, "Only numbers are allowed.")
            .min(10, "Number must be at least 10 digits.")
            .max(20, "Number must not exceed 20 digits."),
              recaptcha: Yup.bool()
                        .oneOf([true], "Please verify the reCAPTCHA")
                        .required("reCAPTCHA is required"),
    });


    const sendEmail = async (values) => {
        if (!isRecaptchaVerified) return;
        try {
            const payload = {
                name: values.name,
                email: values.email,
            };

            // Dummy API call to jsonplaceholder
            const response = await API.post('/contactUs/consultant', payload);

            // Return success if the API call succeeds
            return { status: 'success', data: response.data };
        } catch (error) {
            console.error('Error sending email:', error);
            return { status: 'error', message: error.message };
        }
    };

    const resetForm = (actions) => {
        actions.resetForm();
        actions.setSubmitting(false);
    };



    return (
        <div style={props.style}>
            {/* <SideButtons /> */}
            {/* Header Start */}
            {jobcritic_usertype == 2 ? <HeaderForBus /> : <MainHeader />}
            {/* Header End */}
            <section className="py-[130px] overflow-hidden lg:py-[90px] sm:py-[75px] xs:py-[50px] !pt-[200px] xs:!pt-[75px] md:!pt-[75px]">
                <Container>
                    <Row className="items-center justify-center">
                        <Col lg={5} md={9} className="mb-[10px] md:mb-28 xs:text-center">
                            <h2 className="heading-5 font-serif font-semibold  uppercase mb-[9px] black-class text-[31px]">We’re Just a Message Away</h2>
                            <h3 className="font-serif font-bold   mb-[12px] tracking-[-1px] yellow-class text-[45px] leading-[1.1]">Let’s Talk.</h3>
                            {/* <p className="w-[90%] text-lg mb-[35px] leading-[24px] xs:text-xmd black-class">JobCritics is the world’s first platform where individuals manage ratings and reviews from peers, colleagues, and employers.</p> */}
                            {/*                                 
                                          <Button
                                              className="btn-explore-white bto"
                                              onClick={handleReviewClick}
                                          >
                                              Start Your Free Profile Now
                                          </Button> */}
                        </Col>
                        <Col lg={7} md={9} xs={12} className="px-[55px] md:pr-[50px] md:pl-[5px]">
                            <m.figure className="image-back-offset-shadow w-100">
                                <m.img
                                    className="rounded-[6px] w-auto h-auto"
                                    src={IMAGE_PATHS.ourservices03}
                                    alt="We’re Just a Message Away"
                                    width="572.5"
                                    height="436.53"
                                    initial={{ opacity: 0, x: "0", y: "0" }}
                                    whileInView={{ opacity: 1, x: "10px", y: "-20px" }}
                                    viewport={{ once: true }}
                                    transition={{ delay: 0.4, easing: "linear" }}
                                />
                                <m.span
                                    className="rounded-[6px]"
                                    {...{ ...fadeIn, animate: { x: "35px", y: "5px" } }}
                                ></m.span>
                            </m.figure>
                        </Col>
                    </Row>
                </Container>
            </section>

            <m.section className="py-20 bj">
                <Container>
                    <Row className="justify-center">
                        <Col className="text-center">
                            <h4 className="text-darkgray font-semibold -tracking-[1px]">Frequently asked questions</h4>
                        </Col>
                    </Row>
                    <Row className="justify-center">

                        <Col lg={10} md={10}>
                            <Accordions
                                theme="accordion-style-02 bh"
                                className=""
                                animation={fadeIn}
                                themeColor="light"
                                data={AccordionData}
                            />
                        </Col>
                    </Row>
                </Container>
            </m.section>

            <m.section
                id="call-request"
                className="py-[130px] bg-cover bg-no-repeat overflow-hidden relative bg-center lg:py-[90px] md:py-[75px] sm:py-[50px] xs:py-0 xs:border-y border-b"
                // style={{
                //     backgroundImage: `url(${IMAGE_PATHS.homefinancerequestacallbg})`,
                // }}
                {...fadeIn}
            >
                <Container className="xs:px-0">
                    <m.div className="row justify-center" {...{ ...fadeIn, transition: { delay: 0.6 } }}>
                        <Col xl={7} lg={8} md={10}>
                            <div className="px-28 py-20 rounded-md shadow-[0_0_30px_rgba(0,0,0,0.08)] bg-white sm:p-20 xs:rounded-none xs:px-[3.5rem] xs:py-24">
                                {/* <span className="mb-[15px] font-medium text-center text-[#FFB000] text-md font-serif uppercase block sm:mb-[10px]">
                                    Request a call back
                                </span> */}
                                <h2 className="heading-5 w-[80%] mb-[40px] font-bold text-center tracking-[-1px] text-black font-serif uppercase mx-auto xs:w-full">
                                    Need help for your business?
                                </h2>
                                <Formik
                                    initialValues={{ name: '', email: '', recaptcha: false}}
                                    validationSchema={ContactFormStyle02Schema}

                                    onSubmit={async (values, actions) => {
                                        actions.setSubmitting(true);
                                        const response = await sendEmail(values);
                                        if (response.status === 'success') {
                                            setSuccessMsg(true);  // ✅ show the message
                                            resetForm(actions);
                                            setTimeout(() => setSuccessMsg(false), 5000); // auto-hide after 5s
                                        } else {
                                            actions.setSubmitting(false);
                                            console.error('API Error:', response.message);
                                        }
                                        setIsRecaptchaVerified(false);
                                        recaptchaRef.current?.reset();
                                    }}
                                >
                                    {({ isSubmitting, status, setFieldValue}) => (
                                        <Form className="mb-[30px]">
                                            <Input
                                                showErrorMsg={true}
                                                type="text"
                                                name="name"
                                                labelClass="mb-[25px]"
                                                className="rounded-[5px] py-[15px] px-[20px] w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                                                placeholder="Your name"
                                            />
                                            <Input
                                                showErrorMsg={true}
                                                type="text"
                                                name="email"
                                                labelClass="mb-[25px]"
                                                className="rounded-[5px] py-[15px] px-[20px] w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                                                placeholder="Your contact number"
                                            />
                                            <Col lg={12} className="text-left sm:mb-[20px] mb-[19px]">
                                                <ReCAPTCHA
                                                    ref={recaptchaRef}
                                                    sitekey="6LeMeB0rAAAAANu99dAvFdegQ5rV6L-8plZSr4Fa"
                                                    onChange={(value) => {
                                                        handleRecaptchaChange(value);
                                                        setFieldValue("recaptcha", !!value);
                                                    }}
                                                    className=""
                                                />
                                                <ErrorMessage
                                                    name="recaptcha"
                                                    component="div"
                                                    className="text-error text-sm mt-0 text-left"
                                                />
                                            </Col>
                                            <div className="flex justify-center">
                                              
                                                 <ButtonsVariant
                                                      ariaLabel="submit-button"
                                                      type="submit"
                                                    //   href="#"
                                                      className={`mx-[10px] ${isSubmitting ? ' loading' : ''}`}
                                                      variant="whiteToBlack"
                                                      size="md"
                                                      title="Request a call schedule"
                                                    />
                                            </div>

                                            <AnimatePresence>
                                                {successMsg && (
                                                    <Row>
                                                        <Col xs={12}>
                                                            <m.div
                                                                initial={{ opacity: 0 }}
                                                                animate={{ opacity: 1 }}
                                                                exit={{ opacity: 0 }}
                                                            >
                                                                <MessageBox
                                                                    className="mt-[20px] py-[10px]"
                                                                    theme="message-box01"
                                                                    variant="success"
                                                                    message="Your message has been sent successfully!"
                                                                />
                                                            </m.div>
                                                        </Col>
                                                    </Row>
                                                )}
                                            </AnimatePresence>
                                        </Form>
                                    )}
                                </Formik>
                                <p className="w-[80%] text-xs leading-6 mx-auto xs:w-full text-center">
                                    We are committed to protecting your privacy. We will never collect information about you without your explicit consent.
                                </p>
                            </div>
                        </Col>
                    </m.div>
                </Container>
            </m.section>
            <m.section className="py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px] " {...fadeIn}>
                <Container>
                    <Row className="justify-center">
                        <Col xl={6} lg={7} className="text-center mb-[4.5rem] md:mb-12">
                            <span className="font-serif mb-[5px] -tracking-[.5px] text-xmd block">
                                Fill out the form and we'll be in touch soon!
                            </span>
                            <h4 className="font-serif font-semibold text-darkgray">How we can help you?</h4>
                        </Col>
                        <ContactForm />
                    </Row>
                </Container>
            </m.section>

            <section className="py-[100px] md:py-[75px] sm:py-[50px]">
                <Container>
                    <Row className="justify-center items-center">
                        <Col xs={12} xl={3} lg={4} md={5} sm={6} className="lg:flex lg:justify-end xs:mb-[20px] xs:justify-center">
                            <span className="font-serif font-medium text-xlg text-darkgray inline-block -tracking-[.5px] lg:text-lg">Connect with social media</span>
                        </Col>
                        <Col xs={12} md={2} className="block sm:hidden">
                            <span className="w-full h-[1px] inline-block bg-mediumgray"></span>
                        </Col>
                        <Col xs={12} xl={3} lg={4} md={5} sm={6}>
                            <SocialIcons theme="social-icon-style-01" className="justify-left xs:justify-center xs:text-center" size="sm" iconColor="dark" data={SocialIconsData} />
                        </Col>
                    </Row>
                </Container>
            </section>
            <LetGo
                headingLines={[]}
                subHeading="Build Your Reputation with Verified Ratings!"
            />


            {/* Section Start */}
            <FooterStyle theme="light" className="bg-black text-[#828282] seo-agency-footer_06" />
            {/* Section End */}

        </div>
    )
}

export default Home
